import { render, staticRenderFns } from "./onebarChart.vue?vue&type=template&id=3c0dc749&scoped=true"
import script from "./onebarChart.vue?vue&type=script&lang=js"
export * from "./onebarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0dc749",
  null
  
)

export default component.exports